import { PlaylistType } from '@/enums';
import { Playlists } from '@/pages/Playlists';

export const DigitalSignagePlaylists = () => {
  return <Playlists playlistType={PlaylistType.MIX} />;
};
